<template>
  <div style="min-width: 1200px; min-height: 95vh;">
    <q-card style="min-height: 95vh;">
      <q-form ref="form">
        <div class="row q-pa-md">
          <div class="col-12">
            <div class="d-flex justify-content-between">
              <h4 class="mt-0" style="font-size: 26px; font-weight: 300;">Fortinet Retail Sales</h4>
              <span class="d-block">
                <q-btn @click="closeDialog" class="q-ml-auto" flat icon="close" round size="small"></q-btn>
              </span>
            </div>
          </div>
        </div>
        <div class="row q-pa-md">
          <div class="col-12 px-2">
            <h6>Sales Partner Detail</h6>
          </div>
          <div class="row col-12">
            <div class="col-4 q-pa-sm">
              <q-select disable readonly :options="partners" @filter="filterPartners" class="searchBox p-0" clearable
                        label="Select Partner" lazy-rules outlined use-input
                        v-model="selectedPartner">
                <template v-slot:option="scope">
                  <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                    <q-item-section>
                      <q-item-label class="d-flex justify-content-between">
                        <p>{{ scope.opt.name }}</p>
                        <p>{{ scope.opt.partnerCode }}</p>
                      </q-item-label>
                    </q-item-section>
                  </q-item>
                </template>
                <template v-if="selectedPartner" v-slot:selected>
                  {{ selectedPartner.name }} ({{ selectedPartner.partnerCode }})
                </template>
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-grey">
                      No results
                    </q-item-section>
                  </q-item>
                </template>
              </q-select>
            </div>
          </div>

          <div class="col-12 px-2 mt-3">
            <h6>Customer Detail</h6>
          </div>
          <div class="row col-12">
            <div class="col-6">
              <div class="col-12 q-pa-sm">
                <q-select :options="customerArr"
                          :rules="[val=>val && typeof(val) === 'object' || 'Please select Customer']"
                          @filter="filterCustomer" class="searchBox w-100 p-2 "
                          @input="onSelectCustomer"
                          @blur="onPopupHide" clearable label="Select Customer Company*" outlined filled
                          use-input v-model="customer">
                  <template v-slot:no-option>
                    <q-item>
                      <q-item-section class="text-grey">
                        No results
                      </q-item-section>
                    </q-item>
                  </template>
                  <template v-slot:option="scope">
                    <q-item v-bind="scope.itemProps" v-on="scope.itemEvents"
                            @click="onSelectCustomerOption(scope.opt)">
                      <q-item-section>
                        <q-item-label v-html="scope.opt.companyName"></q-item-label>
                        <q-item-label caption>{{ toLower(scope.opt.email) }}</q-item-label>
                        <q-item-label caption>{{ scope.opt.mobile }}</q-item-label>
                      </q-item-section>
                    </q-item>
                  </template>
                  <template v-slot:selected-item="scope">
                    {{ scope.opt.companyName }}
                  </template>
                </q-select>
              </div>
              <div class="col-6 q-pa-sm">
                <q-input class="searchBox p-2" label="Customer Name"
                         v-model="customerName"></q-input>
              </div>
              <div class="col-12 q-pa-sm">
                <q-input :rules="[val =>val && val.length && val.length === 10 || 'Invalid mobile']"
                         class="searchBox p-2 " label="Customer Mobile" lazy-rules mask="##########"
                         v-model="customerMobile"></q-input>
              </div>
              <div class="col-6 q-pa-sm">
                <q-input class="searchBox p-2" label="Customer Phone" v-model="customerPhone"></q-input>
              </div>
              <div class="col-12 q-pa-sm">
                <q-input :rules="[val =>val && val.length && emailPattern.test(val) || 'Invalid Email']"
                         class="searchBox p-2" label="Customer Email" lazy-rules type="email"
                         v-model="customerEmail"></q-input>
              </div>
              <div class="col-6 q-pa-sm">
                <q-input class="searchBox p-2" label="Customer City" v-model="customerCity"></q-input>
              </div>
            </div>
            <div class="col-6">
              <div class="col-12 q-pa-sm">
                <q-input class="searchBox p-2" label="Invoice No." v-model="invoiceNumber"></q-input>
              </div>
              <div class="col-6 q-pa-sm">
                <q-input class="searchBox p-2" filled label="Invoice Date" mask="##/##/####"
                         v-model="invoiceDateComp">
                  <template v-slot:append>
                    <q-icon class="cursor-pointer " name="event">
                      <q-popup-proxy ref="invoiceDate" transition-hide="scale"
                                     transition-show="scale">
                        <q-date @input="() => $refs.invoiceDate.hide()" v-model="invoiceDate"/>
                      </q-popup-proxy>
                    </q-icon>
                  </template>
                </q-input>
              </div>
              <div class="col-6 q-pa-sm">
                <q-input class="searchBox" label="Note/Remark" style="min-height: 115px" type="textarea"
                         v-model="invoiceNote"></q-input>
              </div>
            </div>
          </div>
        </div>
        <div class="row ">
          <div class="col-6 q-pa-sm">
            <div class="col-12 px-3 mt-3">
              <h6>Product Detail</h6>
            </div>
            <div class="col-6 mt-2 pl-3">
              <q-select :options="batchArr" @filter="searchBatch" class="searchBox p-2 mb-3" clearable
                        label="Search by batch no. to transfer" outlined
                        @input="onSelectBatch" use-input v-model="selectedBatch">
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-grey">
                      No results
                    </q-item-section>
                  </q-item>
                </template>
                <template v-slot:option="scope">
                  <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                    <q-item-section>
                      <q-item-label v-html="scope.opt.batch"></q-item-label>
                      <q-item-label caption>{{
                          scope.opt.Product ? scope.opt.Product.name : ''
                        }}
                      </q-item-label>
                    </q-item-section>
                  </q-item>
                </template>
                <template v-slot:selected-item="scope">
                  {{ scope.opt.batch }} {{
                    scope.opt.Product ? ' (' + scope.opt.Product.name + ')' :
                        ''
                  }}
                </template>
              </q-select>
            </div>
            <!-- HIDE Functional Add to Cart (Automatic) -->
            <div class="hidden">
              <div class="d-flex justify-content-between q-pa-md pb-0">
                <div style="width: 100%">
                  <div class="mb-3">
                    <div class="d-flex justify-content-between" style="align-items: center;">
                      <p class="mb-0">Select Sub-Batch Number</p>
                    </div>
                  </div>
                  <div class="sectionOne position-relative" style="height: 10vh !important;">
                    <div class="overflow-hidden"
                         style="min-height: 20px !important; margin-top: 0; ">
                      <div class="py-3 section-list" v-for="inventory in productInventoryArr">
                        <q-checkbox :val="inventory.id" v-model="groupOneSelection">
                          <div><span style="font-size: 16px; font-weight: 500;">{{ inventory.serial }}</span>
                          </div>
                          <div><span style="font-size: 14px; color: #878787">{{ inventory.Product.name }}</span>
                          </div>
                        </q-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <transition name="fade">
                <div class="d-flex" v-if="groupOneSelection.length&&productInventoryArr.length">
                  <q-space></q-space>
                  <q-btn @click="addToCart" class="pd-btn mt-3"
                         style="'margin-right: 16px;margin-top: -6px;'">
                    Add to Cart
                  </q-btn>
                </div>
              </transition>
            </div>
          </div>

          <div class="col-12 q-pa-sm" v-if="groupTwoSelection.length">
            <div class="d-flex justify-content-between q-pa-md" style="align-items: center">
              <div style="width: 100%">
                <div class="row" v-for="(item,index) in groupTwoSelection" :key="index">
                  <div class="col-6 pr-3">
                    <div class="d-flex justify-between mb-3">
                      <h6>Selected Serial Number</h6>
                      <q-btn flat round small color="red"
                             @click="removeInventoryItem(index,item.id)"
                             icon="delete_outline">
                        <q-tooltip content-style="font-size: 12px" :offset="[10, 10]">Remove
                          SKU
                        </q-tooltip>
                      </q-btn>
                    </div>
                    <div class="row">
                      <div class="col-6 q-pa-sm">
                        <span class="bankLabel">SKU</span>
                        <p>{{ item.sku }}</p>
                      </div>
                      <div class="col-6 q-pa-sm">
                        <span class="bankLabel">Serial Number</span>
                        <p>{{ item.serial }}</p>
                      </div>
                      <div class="col-12 q-pa-sm">
                        <span class="bankLabel">Product Key</span>
                        <q-input class="searchBox" placeholder="Enter product key"
                                 mask="XXXX-XXXX-XXXX-XXXX-XXXX"
                                 filled v-model="item.productKey"></q-input>
                      </div>
                      <div class="col-6 q-pa-sm">
                        <span class="bankLabel">Activation Date</span>
                        <q-input class="py-2 searchBox" filled v-model="item.activationDate"
                                 mask="##-##-####" :rules="[val=>val && val.length>0 || 'Please select Activation date',
                                                                  val => val.length && datePattern.test(val) || 'Invalid Date']">
                          <template v-slot:append>
                            <q-icon name="event" class="cursor-pointer">
                              <q-popup-proxy transition-show="scale" transition-hide="scale"
                                             :ref="'qDateProxyActivationDate'+index">
                                <q-date v-model="item.activationDate" mask="DD-MM-YYYY"
                                        @input="forceUpdateTable('qDateProxyActivationDate'+index)"></q-date>
                              </q-popup-proxy>
                            </q-icon>
                          </template>
                        </q-input>
                      </div>
                      <div class="col-6 q-pa-sm">
                        <span class="bankLabel">Expiry Date</span>
                        <p class="mb-0">{{
                            item.activationDate ? moment(item.activationDate, 'DD-MM-YYYY').
                                add(item.Product.validity ? item.Product.validity : 365, 'days').
                                format('DD-MM-YYYY') : '-'
                          }}</p>
                      </div>
                      <div class="col-12 q-pa-sm">
                        <span class="bankLabel">Remark</span>
                        <q-input class="searchBox" filled v-model="item.remark"></q-input>
                      </div>
                    </div>
                  </div>

                  <div class="col-6">
                    <div class="row">
                      <div class="col-12 mb-3">
                        <h6>Support Plan Detail</h6>
                      </div>
                      <div class="col-12 mb-3 mt-2">
                        <span class="bankLabel">Support Plan</span>
                        <q-select :options="supportPlans" class="searchBox" filled outlined
                                  v-model="item.supportPlan">
                          <template v-slot:option="scope">
                            <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                              <q-item-section>
                                <q-item-label class="d-flex justify-content-between">
                                  <p>{{ scope.opt.name }}</p>
                                </q-item-label>
                              </q-item-section>
                            </q-item>
                          </template>
                          <template v-if="selectedSupportPlan" v-slot:selected> {{
                              item.supportPlan.name
                            }}
                          </template>
                          <template v-slot:no-option>
                            <q-item>
                              <q-item-section class="text-grey">No results
                              </q-item-section>
                            </q-item>
                          </template>
                        </q-select>
                      </div>
                      <div class="col-12 mb-3">
                        <span class="bankLabel">Activation Date</span>
                        <q-input class="py-2 searchBox" filled v-model="item.planActivationDate"
                                 mask="##-##-####" :rules="[val=>val && val.length>0 || 'Please select Activation date',
                                                                            val => val.length && datePattern.test(val) || 'Invalid Date']">
                          <template v-slot:prepend>
                            <q-icon name="event" class="cursor-pointer">
                              <q-popup-proxy transition-show="scale"
                                             transition-hide="scale"
                                             :ref="'qDateProxyPlanActivationDate'+index">
                                <q-date v-model="item.planActivationDate"
                                        mask="DD-MM-YYYY"
                                        @input="forceUpdateTable('qDateProxyPlanActivationDate'+index)"></q-date>
                              </q-popup-proxy>
                            </q-icon>
                          </template>
                        </q-input>
                      </div>
                      <div class="col-12 ">
                        <span class="bankLabel">Expiry Date</span>
                        <p class="mb-0">
                          {{
                            item.planActivationDate ? moment(item.planActivationDate,
                                'DD-MM-YYYY').
                                add(item.supportPlan ? item.supportPlan.duration : 365, 'days').
                                format('DD-MM-YYYY') : '-'
                          }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <q-space></q-space>
            <q-btn @click="onAddOrder" class="pd-btn float-right mt-3"
                   v-show="groupTwoSelection.length">Transfer
            </q-btn>
          </div>
          <!--
          <q-table :columns="columns" :data="groupTwoSelection" dense :pagination.sync="pagination" flat
                   row-key="name" table-class="table-class"
                   table-header-style="background-color:#f9f9f9fa;color: black;height: 36px;">
            <template v-slot:body-cell-action="props">
              <q-td :props="props">
                <q-btn flat round small color="red" size="12px" @click="removeInventoryItem(props)"
                       icon="delete_outline" class="delete-btn">
                  <q-tooltip content-style="font-size: 12px" :offset="[10, 10]">Remove SKU</q-tooltip>
                </q-btn>
              </q-td>
            </template>
            <template v-slot:body-cell-productKey="props">
              <q-td :props="props">
                <q-input class="searchBox" placeholder="Enter product key" mask="XXXX-XXXX-XXXX-XXXX-XXXX"
                         filled v-model="props.row.productKey"></q-input>
              </q-td>
            </template>
            <template v-slot:body-cell-activationDate="props">
              <q-td :props="props">
                <q-input class="py-2" filled v-model="props.row.activationDate" mask="##-##-####" :rules="[val=>val && val.length>0 || 'Please select Activation date',
                                                                            val => val.length && datePattern.test(val) || 'Invalid Date']">
                  <template v-slot:prepend>
                    <q-icon name="event" class="cursor-pointer">
                      <q-popup-proxy transition-show="scale" transition-hide="scale"
                                     :ref="'qDateProxy'+props.row.__index">
                        <q-date v-model="props.row.activationDate" mask="DD-MM-YYYY"
                                @input="forceUpdateTable('qDateProxy'+props.row.__index)"></q-date>
                      </q-popup-proxy>
                    </q-icon>
                  </template>
                </q-input>
              </q-td>
            </template>
            <template v-slot:body-cell-expiryDate="props">
              <q-td :props="props">
                {{
                  props.row.activationDate ? moment(props.row.activationDate, 'DD-MM-YYYY').
                      add(props.row.Product.validity ? props.row.Product.validity : 365, 'days').
                      format('DD-MM-YYYY') : '-'
                }}
              </q-td>
            </template>
            <template v-slot:body-cell-supportPlan="props">
              <q-td :props="props">
                <q-select :options="supportPlans" class="searchBox" filled outlined
                          v-model="props.row.supportPlan">
                  <template v-slot:option="scope">
                    <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                      <q-item-section>
                        <q-item-label class="d-flex justify-content-between">
                          <p>{{ scope.opt.name }}</p>
                        </q-item-label>
                      </q-item-section>
                    </q-item>
                  </template>
                  <template v-if="selectedSupportPlan" v-slot:selected> {{
                      props.row.supportPlan.name
                    }}
                  </template>
                  <template v-slot:no-option>
                    <q-item>
                      <q-item-section class="text-grey"> No results</q-item-section>
                    </q-item>
                  </template>
                </q-select>
              </q-td>
            </template>
            <template v-slot:body-cell-planActivationDate="props">
              <q-td :props="props">
                <q-input class="py-2" filled v-model="props.row.planActivationDate" mask="##-##-####" :rules="[val=>val && val.length>0 || 'Please select Activation date',
                                                                            val => val.length && datePattern.test(val) || 'Invalid Date']">
                  <template v-slot:prepend>
                    <q-icon name="event" class="cursor-pointer">
                      <q-popup-proxy transition-show="scale" transition-hide="scale"
                                     :ref="'qDateProxy'+props.row.__index">
                        <q-date v-model="props.row.planActivationDate" mask="DD-MM-YYYY"
                                @input="forceUpdateTable('qDateProxy'+props.row.__index)"></q-date>
                      </q-popup-proxy>
                    </q-icon>
                  </template>
                </q-input>
              </q-td>
            </template>
            <template v-slot:body-cell-planExpiryDate="props">
              <q-td :props="props">
                {{
                  props.row.planActivationDate ? moment(props.row.planActivationDate, 'DD-MM-YYYY').
                      add(props.row.supportPlan ? props.row.supportPlan.duration : 365, 'days').
                      format('DD-MM-YYYY') : '-'
                }}
              </q-td>
            </template>
            <template v-slot:body-cell-remark="props">
              <q-td :props="props">
                <q-input class="searchBox" filled v-model="props.row.remark"></q-input>
              </q-td>
            </template>
            <template v-slot:bottom="props">
              <q-space></q-space>
              <q-btn @click="onAddOrder" class="pd-btn float-right mt-3" style="margin-right: -14px"
                     v-show="groupTwoSelection.length">Transfer
              </q-btn>
            </template>
          </q-table>
          -->
        </div>
      </q-form>
    </q-card>
  </div>
</template>

<script>
import moment from 'moment'
import { GET_CUSTOMERS } from '@/graphql/queries/Customers'
import { INSERT_CUSTOMER, UPDATE_CUSTOMER } from '@/graphql/mutations/customer'
import { GET_FORTINET_INVENTORY_BY_BATCH, GET_PRODUCT_INVENTORY_BY_BATCHID } from '@/graphql/queries/products'
import { INSERT_ORDER_ITEMS, INSERT_ORDERS } from '@/graphql/mutations/products'
import { GET_ALL_PARTNERS } from '@/graphql/queries/schemePoints'
import Constants from '@/Constants/Constant'
import { GET_PRODUCT_SUPPORT_PLANS } from '@/graphql/queries/support'
import { INSERT_AMC_PLAN_HISTORY } from '@/graphql/mutations/support'

export default {
  name: 'RetailSalesFortinet',
  apollo: {
    Organizations: {
      query: GET_ALL_PARTNERS,
      result ({ data, loading }) {
        if (!loading) {
          this.partners = data.Organizations
          this.tempPartners = data.Organizations
        }
      },
    },
    customerArr: {
      query: GET_CUSTOMERS,
      fetchPolicy: 'network-only',
      variables () {
        return { orgId: this.selectedPartner.id }
      },
      result ({ data, loading }) {
        if (!loading) {
          this.temp_customerArr = JSON.parse(JSON.stringify(data.customerArr))
        }
      },
    },
    SupportPlans: {
      query: GET_PRODUCT_SUPPORT_PLANS,
      fetchPolicy: 'network-only',
      result ({ data, loading }) {
        if (!loading) {
          this.supportPlans = data.SupportPlans
        }
      },
    },
  },
  data: function () {
    return {
      moment: moment,
      user: JSON.parse(localStorage.getItem('user')),
      emailPattern: new RegExp(
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
      datePattern: new RegExp(/^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/),
      partners: [],
      tempPartners: [],
      customerArr: [],
      temp_customerArr: [],
      supportPlans: [],
      selectedSupportPlan: Constants.DEFAULT_SUPPORT_PLAN,
      selectedPartner: Constants.AIPL_PARTNER,
      customer: '',
      customerMobile: '',
      customerEmail: '',
      customerName: '',
      customerPhone: '',
      customerCity: '',
      invoiceDate: null,
      invoiceDateComp: null,
      invoiceNumber: '',
      orderDate: moment(),
      orderDateComp: moment().format('DD/MM/YYYY'),
      invoiceNote: '',
      batchFilter: '%%',
      batchArr: [],
      selectedBatch: '',
      tempValue: null,
      productInventoryArr: [],
      groupOneSelection: [],
      groupTwoSelection: [],
      columns: [
        { name: 'sku', label: 'SKU', field: row => row.sku, align: 'left', sortable: true },
        {
          name: 'serialNumber',
          label: 'Sub-batch No',
          field: row => row.serial,
          align: 'left',
          sortable: true,
        },
        { name: 'productKey', label: 'Product Key', field: 'productKey', align: 'left', sortable: true },
        {
          name: 'activationDate',
          label: 'Activation Date',
          field: 'activationDate',
          align: 'left',
          sortable: true,
        },
        { name: 'expiryDate', label: 'Expiry Date', field: 'expiryDate', align: 'left', sortable: true },
        { name: 'supportPlan', label: 'Support Plan', field: 'supportPlan', align: 'left', sortable: true },
        {
          name: 'planActivationDate', label: 'Activation Date', field: 'planActivationDate',
          align: 'left', sortable: true,
        },
        {
          name: 'planExpiryDate',
          label: 'Expiry Date',
          field: 'planExpiryDate',
          align: 'left',
          sortable: true,
        },
        { name: 'remark', label: 'Remark', field: 'remark', align: 'left', sortable: false },
        { name: 'action', label: '', field: 'action', align: 'left', sortable: true },
      ],
      pagination: { rowsPerPage: 200 },
    }
  },
  watch: {
    invoiceDate (val) {
      this.invoiceDateComp = moment(val).format('DD/MM/YYYY')
    },
    orderDate (val) {
      this.orderDateComp = moment(val).format('DD/MM/YYYY')
    },
  },
  methods: {
    filterPartners (val, update, abort) {
      if (val === '') {
        update(() => {
          this.partners = JSON.parse(JSON.stringify(this.tempPartners))
        })
        return
      }
      update(() => {
        const needle = val.toLowerCase()
        this.partners = this.tempPartners.filter(
            v => ((v.name?.toLowerCase().indexOf(needle) > -1) || (v.partnerCode?.toLowerCase().indexOf(needle) > -1)))
      })
    },
    closeDialog () {
      this.$emit('closeRetailSalesDialog', false)
    },
    addToCart () {
      let tempArr = this.groupOneSelection.map((id) => this.groupTwoSelection.find((obj) => obj.id === id) ||
          this.productInventoryArr.find((obj) => obj.id === id))
      tempArr.forEach(function (curnt) {               //Autofill activationDate by Today's date
        if (!curnt.hasOwnProperty('activationDate')) {
          curnt.activationDate = moment().format('DD-MM-YYYY')
        }
        curnt['supportPlan'] = Constants.DEFAULT_SUPPORT_PLAN
        curnt['planActivationDate'] = moment().format('DD-MM-YYYY')
        curnt['planExpiryDate'] = ''
      })
      this.groupTwoSelection = JSON.parse(JSON.stringify(tempArr))       //To fix referencing error(To avoid -> on update groupTwoSelection updates other arrays)
    },
    addToCartAuto () {
      if (this.productInventoryArr.length) {
        this.groupOneSelection = []
        this.groupOneSelection.push(this.productInventoryArr[0].id)
        this.addToCart()
      }
    },
    removeInventoryItem (index, id) {
      this.groupTwoSelection.splice(index, 1)
      this.groupOneSelection.splice(this.groupOneSelection.indexOf(id), 1)
    },
    onSelectCustomer (val) {
      this.tempValue = null
      if (val) {
        this.customerMobile = val.mobile
        this.customerEmail = val.email
        this.customerPhone = val.phone
        this.customerCity = val.city
        this.customerName = val.name
      } else {
        this.customerPhone = ''
        this.customerCity = ''
        this.customerName = ''
        this.customerMobile = ''
        this.customerEmail = ''
        this.customer = ''
      }
    },
    onSelectCustomerOption (row) {
      this.customer = {
        id: row.id, name: row.name, mobile: row.mobile, email: row.email, phone: row.phone,
        city: row.city, companyName: row.companyName,
      }
      this.customerMobile = row.mobile
      this.customerEmail = row.email
      this.customerName = row.name
      this.customerCity = row.city
      this.customerPhone = row.phone
    },
    onSelectBatch (val) {
      if (val) {
        this.fetchProductInventory(val.id)
      } else {
        this.productInventoryArr = []
      }
    },
    async fetchProductInventory (batchId) {
      let response = await this.$apollo.query({
        query: GET_PRODUCT_INVENTORY_BY_BATCHID,
        fetchPolicy: 'network-only',
        variables: {
          ownedBy: this.selectedPartner.id,
          batchId: batchId,
          status: 'InStock',
        },
      })
      if (response.data) {
        this.productInventoryArr = response.data.ProductInventory
        this.addToCartAuto()
      }
    },
    onPopupHide () {
      if (this.tempValue) {
        this.customerArr.push({ companyName: this.tempValue })
        this.customer = { companyName: this.tempValue }
      }
    },
    filterCustomer (val, update, abort) {
      if (val === '') {
        update(() => {
          this.customerArr = JSON.parse(JSON.stringify(this.temp_customerArr))
        })
        return
      }
      update(() => {
        this.tempValue = val
        this.customerArr = this.temp_customerArr.filter(function (el) {
          return (el.name?.toLowerCase().indexOf(val.toLowerCase()) > -1 ||
              el.email?.toLowerCase().indexOf(val.toLowerCase()) > -1 ||
              el.mobile?.toLowerCase().indexOf(val.toLowerCase()) > -1 ||
              el.phone?.toLowerCase().indexOf(val.toLowerCase()) > -1 ||
              el.companyName?.toLowerCase().indexOf(val.toLowerCase()) > -1
          )
        })
      })
    },
    async searchBatch (val, update, abort) {
      let splitted = val.split(' ')
      if (splitted.length <= 1) {
        if (val.length < 1) {
          abort()
          return
        }
        let response = await this.$apollo.query({
          query: GET_FORTINET_INVENTORY_BY_BATCH,
          fetchPolicy: 'network-only',
          variables: {
            ownedBy: this.selectedPartner.id, 
            batchFilter: '%' + val + '%', 
            status: 'InStock',
            oemCode: 'Fortinet'
          },
        })
        if (response.data)
          this.batchArr = response.data.BatchTable
        update(() => {
        })
      }
    },
    onAddOrder () {
      let self = this
      this.$refs['form'].validate().then(success => {
        if (success && self.customer.id) {
          self.confirm(self.updateCustomer, self.customer.id)
        } else if (success) {
          self.confirm(self.insertCustomer)
        }
      })
    },
    confirm (callback, customerId) {
      let self = this
      this.$q.dialog({
        title: 'Confirm', message: 'Are you sure?', cancel: true, persistent: false,
      }).onOk(() => {
        callback(customerId)
      }).onCancel(() => {
        // console.log('>>>> Cancel')
      })
    },
    async insertOrder (customerId) {
      let self = this
      let orderRequest = {
        id: this.generateUUID(),
        date: moment(),                     //set Today's date for Retail-Sales
        from: self.selectedPartner.id,
        to: customerId,
        lineItemCounts: this.groupTwoSelection.length,
        status: 'InTransit',
        placedBy: self.user.id,
        notes: '',
        invoiceNumber: self.invoiceNumber,
        invoiceNote: self.invoiceNote,
        invoiceDate: self.invoiceDate ? self.invoiceDate : null,
        orderType: Constants.ORDER_TYPES.RETAIL_SALES_FORTINET,
      }
      let response = await this.$apollo.mutate({
        mutation: INSERT_ORDERS,
        variables: orderRequest,
      })
      if (response.data) {
        this.insertOrderItems(orderRequest)
      }
    },
    insertOrderItems (orderRequest) {
      let self = this
      let orderItemRequest
      let counter = this.groupTwoSelection.length
      for (var i = 0; i < this.groupTwoSelection.length; i++) {
        let inv = this.groupTwoSelection[i]
        orderItemRequest = {
          id: self.generateUUID(),
          orderId: orderRequest.id,
          qty: orderRequest.lineItemCounts,
          from: orderRequest.from,
          to: orderRequest.to,
          notes: '',
          sellType: Constants.ORDER_TYPES.RETAIL_SALES_FORTINET.toString(),
          batchId: inv.batchId,
          productInventoryId: inv.id,
          productId: inv.Product.id,
          status: 'Sold',
          meta: {
            activationDate: inv.activationDate, productKey: inv.productKey, remark: inv.remark,
            expiryDate: moment(inv.activationDate, 'DD-MM-YYYY').
                add(inv.Product.validity ? inv.Product.validity : 365, 'days').
                format('DD-MM-YYYY'),
          },
        }
        this.$apollo.mutate({
          mutation: INSERT_ORDER_ITEMS,
          variables: orderItemRequest,
        }).then(function (response) {
          counter--
          self.$apollo.mutate({
            mutation: INSERT_AMC_PLAN_HISTORY,
            variables: {
              serialNo: inv.serial,
              retailSalesId: orderItemRequest.id,
              supportPlanId: inv.supportPlan.id,
              productId: orderItemRequest.productId,
              startDate: moment(inv.planActivationDate, 'DD-MM-YYYY'),
              endDate: inv.planActivationDate ? moment(inv.planActivationDate, 'DD-MM-YYYY').
                  add(inv.supportPlan ? inv.supportPlan.duration : 365, 'days') : moment(),
              noOfSupportRaised: 0,
              fromPartnerId: self.selectedPartner.id,
              createdBy: self.user.orgId,
              updatedBy: self.user.orgId,
            },
          }).then(res => {
            self.groupOneSelection = []
            self.groupTwoSelection = []
            self.$q.notify('Retail Sales Order Placed Successfully')
            self.$emit('closeRetailSalesDialog', false)
          })
        })
      }
    },
    async insertCustomer () {
      let customerRequest = {
        id: this.generateUUID(), name: this.customerName,
        mobile: this.customerMobile, email: this.customerEmail,
        phone: this.customerPhone, city: this.customerCity,
        companyName: this.customer.companyName, orgId: this.selectedPartner.id,
      }
      let response = await this.$apollo.mutate({
        mutation: INSERT_CUSTOMER,
        variables: customerRequest,
      })
      if (response.data) {
        this.insertOrder(customerRequest.id)
      }
    },
    async updateCustomer (customerId) {
      let customerRequest = {
        id: customerId, name: this.customerName,
        mobile: this.customerMobile, email: this.customerEmail,
        phone: this.customerPhone, city: this.customerCity,
        companyName: this.customer.companyName, orgId: this.selectedPartner.id,
      }
      let response = await this.$apollo.mutate({
        mutation: UPDATE_CUSTOMER,
        variables: customerRequest,
      })
      if (response.data) {
        this.insertOrder(customerId)
      }
    },
    generateUUID () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    },
    forceUpdateTable (name) {
      this.groupTwoSelection = JSON.parse(JSON.stringify(this.groupTwoSelection))
      this.$refs[name][0].hide()
      // this.$refs[name].hide()
    },
  },
  mounted () {
    this.selectedPartner = {
      id: this.user.organization.id, name: this.user.organization.name,
      partnerCode: this.user.organization.partnerCode,
    }
  },
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 1s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

/deep/ .q-table__middle {
  border: 1px solid #d0d0d087;
}

</style>
